module.exports = __webpack_public_path__ + "img/sy_n1.95126573.jpg";